module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "FM01"
    }
  }, [_c('p', {
    staticClass: "fm-noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('b', [_vm._v("Note")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "fm-noindent1"
  }, [_vm._v("Terms relating to ufology are included in a glossary at the end of this book.")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-831fb18e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_FM01.vue
// module id = 75
// module chunks = 0